module.exports = __webpack_public_path__ + "img/debtPayingAbility6.697909c4.png";